(function () {
  const form = document.getElementById("mcuContactForm");
  if (!form) return;

  const nameInput    = document.getElementById("mcuName");
  const phoneInput   = document.getElementById("mcuPhone");
  const messageInput = document.getElementById("mcuMessage");
  const subjectInput = document.getElementById("mcuSubject");
  const submitBtn    = document.getElementById("mcuSubmitBtn");
  const successBox   = document.getElementById("mcuFormSuccess");
  const btnText      = submitBtn && submitBtn.querySelector(".mcu-form__btn-text");
  const btnLoading   = submitBtn && submitBtn.querySelector(".mcu-form__btn-loading");

  function showErr(inputEl, errId, msg) {
    var errEl = document.getElementById(errId);
    if (errEl) errEl.textContent = msg;
    inputEl.classList.add("mcu-form__input--error");
  }

  function clearErr(inputEl, errId) {
    var errEl = document.getElementById(errId);
    if (errEl) errEl.textContent = "";
    inputEl.classList.remove("mcu-form__input--error");
  }

  function validate() {
    var valid = true;

    clearErr(nameInput, "mcuNameErr");
    clearErr(phoneInput, "mcuPhoneErr");
    clearErr(messageInput, "mcuMessageErr");

    if (!nameInput.value.trim()) {
      showErr(nameInput, "mcuNameErr", "من فضلك اكتبي اسمك");
      valid = false;
    }

    var phone = phoneInput.value.trim().replace(/\s/g, "");
    if (!phone) {
      showErr(phoneInput, "mcuPhoneErr", "من فضلك اكتبي رقم هاتفك");
      valid = false;
    } else if (!/^(\+?20|0)?1[0-9]{9}$/.test(phone)) {
      showErr(phoneInput, "mcuPhoneErr", "الرقم غير صحيح — مثال: 01012345678");
      valid = false;
    }

    if (!messageInput.value.trim()) {
      showErr(messageInput, "mcuMessageErr", "من فضلك اكتبي رسالتك");
      valid = false;
    }

    return valid;
  }

  function buildWhatsAppUrl() {
    var name    = nameInput.value.trim();
    var phone   = phoneInput.value.trim();
    var subject = subjectInput ? subjectInput.options[subjectInput.selectedIndex].text : "";
    var message = messageInput.value.trim();

    var subjectLabels = {
      "": "",
      "products":   "استفسار عن منتج",
      "membership": "الانضمام للعضوية",
      "order":      "متابعة طلب",
      "complaint":  "شكوى أو اقتراح",
      "other":      "أخرى",
    };
    var subjectVal = subjectInput ? subjectInput.value : "";
    var subjectText = subjectLabels[subjectVal] || subject;

    var text = "السلام عليكم، أنا " + name + "\n";
    if (subjectText) text += "الموضوع: " + subjectText + "\n";
    text += "رقمي: " + phone + "\n\n";
    text += message;

    return "https://api.whatsapp.com/send?phone=201010764682&text=" + encodeURIComponent(text);
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    if (!validate()) return;

    submitBtn.disabled = true;
    if (btnText)    btnText.hidden    = true;
    if (btnLoading) btnLoading.hidden = false;

    setTimeout(function () {
      if (successBox) successBox.hidden = false;

      var waUrl = buildWhatsAppUrl();
      window.open(waUrl, "_blank", "noopener,noreferrer");

      submitBtn.disabled = false;
      if (btnText)    btnText.hidden    = false;
      if (btnLoading) btnLoading.hidden = true;
    }, 600);
  });

  [nameInput, phoneInput, messageInput].forEach(function (el) {
    if (!el) return;
    el.addEventListener("input", function () {
      el.classList.remove("mcu-form__input--error");
    });
  });
})();
